import type { DriveStep } from 'driver.js';

export const clientsTourSteps: DriveStep[] = [
  {
    element: '[data-tour="client-add-btn"]',
    popover: {
      title: 'Neuen Klienten anlegen',
      description: 'Klicke hier, um einen neuen Coaching-Klienten hinzuzufügen. Name, E-Mail und Coaching-Thema eingeben.',
      side: 'bottom',
      align: 'start',
    },
  },
  {
    element: '[data-tour="client-search"]',
    popover: {
      title: 'Klienten suchen',
      description: 'Durchsuche deine Klienten nach Name oder E-Mail.',
      side: 'bottom',
      align: 'start',
    },
  },
  {
    element: '[data-tour="client-export"]',
    popover: {
      title: 'Exportieren',
      description: 'Exportiere deine Klientenliste als CSV oder PDF — z.B. für die Steuererklärung.',
      side: 'bottom',
      align: 'end',
    },
  },
  {
    element: '[data-tour="client-list"]',
    popover: {
      title: 'Klientenliste',
      description: 'Klicke auf einen Klienten, um sein Profil mit Fällen, Sitzungen, Rechnungen und Dokumenten zu sehen.',
      side: 'top',
      align: 'center',
    },
  },
];
